import * as yup from 'yup';

export const maxTextLength = 5000;
export const maxDeclineReasonLength = 1000;
export const maxFiles = 10;
export const maxFileSizeMb = 20;
export const maxUploadSizeMb = 25;

const megabytes = (size) => size * 1024 * 1024;

const text = (label, max = maxTextLength) =>
  yup.string().trim().max(max, `${label} must be at most ${max} characters`);

const files = yup
  .array()
  .test('count', `At most ${maxFiles} files can be attached`, function (value = []) {
    return value.length + (this.parent.keptFiles?.length ?? 0) <= maxFiles;
  })
  .test('file-size', `Each file must be at most ${maxFileSizeMb} MB`, (value = []) =>
    value.every((file) => file.size <= megabytes(maxFileSizeMb))
  )
  .test(
    'total-size',
    `Attachments must be at most ${maxUploadSizeMb} MB in total`,
    (value = []) =>
      value.reduce((total, file) => total + file.size, 0) <= megabytes(maxUploadSizeMb)
  );

export const questionValidationSchema = yup.object().shape({
  question: text('Question').required('Question is required'),
  files,
});

export const answerValidationSchema = yup.object().shape({
  publish: yup.boolean(),
  editQuestion: yup.boolean(),
  revisedQuestion: text('Edited question').when('editQuestion', {
    is: true,
    then: (schema) => schema.required('Edited question is required'),
  }),
  answer: text('Answer').when('publish', {
    is: true,
    then: (schema) => schema.required('Answer is required'),
  }),
  visibility: yup
    .string()
    .oneOf(['', 'public', 'limited'])
    .when('publish', {
      is: true,
      then: (schema) =>
        schema
          .oneOf(['public', 'limited'], 'Visibility is required')
          .required('Visibility is required'),
    }),
  files,
});

export const declineValidationSchema = yup.object().shape({
  reason: text('Reason', maxDeclineReasonLength).required('Reason is required'),
});

export const notificationValidationSchema = yup.object().shape({
  publish: yup.boolean(),
  text: text('Notification').required('Notification is required'),
  files,
});
